import { Fancybox } from '@fancyapps/ui'

const Common = async () => {
    Fancybox.bind('[data-fancybox]');

    return true
}

export default Common
